import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { Box, Typography } from '@mui/material';

const t = (key, options?) => translate('teachingOrder', key, options);

const ConfirmOrderChangeModal = ({ name }) => {
  return (
    <Box>
      <Typography variant="subtitle1">
        {t('areYouSureOrder1')} &quot;
        {name}
        &quot; {t('areYouSureOrder2')}?
      </Typography>
    </Box>
  );
};

export default ConfirmOrderChangeModal;
